import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    loginFetchSuccess,
    loginFetchFailure,
    logoutFetchSuccess,
    logoutFetchFailure,
    setLogged,
    forgetPasswordFetchSuccess,
    forgetPasswordFetchFailure,
} from './reducer';
import { getUserFetch } from '../user/reducer';
import { LoginResType, LoginReqDataType, ForgetPasswordReqDataType } from 'src/types/login';
import cleareLocalStorage from 'src/utils/cleareLocalStorage';
import { NavigateFunction } from 'react-router-dom';
import { bootstrapDebug } from 'src/utils/bootstrapDebug';

const loginFetchRequest = async (params: LoginReqDataType) => {
    const res = await api('post', 'api/public/authenticate?system=myskladon', params, { withoutExtend: true });
    return res.data;
};

function* loginFetch(action: { type: string; payload: LoginReqDataType }) {
    bootstrapDebug('login:saga:start');
    try {
        const response: LoginResType = yield call((): Promise<LoginResType> => loginFetchRequest(action.payload));
        bootstrapDebug('login:authenticate:done');

        yield call(() => {
            localStorage.setItem('token', response.token);
            localStorage.setItem('expiresIn', String(response.expiresIn * 1000));
            localStorage.setItem('refreshToken', response.refreshToken);
        });

        yield put(loginFetchSuccess());
        bootstrapDebug('login:success', { hasToken: Boolean(localStorage.getItem('token')) });

        if (localStorage.getItem('token')) {
            bootstrapDebug('login:dispatch getUserFetch');
            yield put(getUserFetch());
        }
    } catch (error) {
        bootstrapDebug('login:failure', {
            error: error instanceof Error ? error.message : String(error),
        });
        yield put(loginFetchFailure({}));
    }
}

export function* loginFetchWatch() {
    yield takeEvery('login/loginFetch', loginFetch);
}

const forgetPasswordFetchRequest = async (params: ForgetPasswordReqDataType) => {
    const res = await api('post', 'api/public/forgotten-password', params, { withoutExtend: true });
    return res.data;
};

function* forgetPasswordFetch(action: { type: string; payload: ForgetPasswordReqDataType }) {
    try {
        const response: LoginResType = yield call((): any => forgetPasswordFetchRequest(action.payload));

        yield put(forgetPasswordFetchSuccess());
    } catch (error) {
        yield put(forgetPasswordFetchFailure({}));
    }
}

export function* forgetPasswordFetchWatch() {
    yield takeEvery('login/forgetPasswordFetch', forgetPasswordFetch);
}

const logoutFetchRequest = async () => {
    const res = await api('post', 'api/public/authenticate');
    return res.data;
};

function* logoutFetch(action: { type: string; payload?: { navigate: NavigateFunction } }) {
    try {
        const response: LoginResType = yield call((): any => logoutFetchRequest());

        yield call(() => {
            localStorage.setItem('token', response.token);
        });

        yield put(logoutFetchSuccess());

        if (localStorage.getItem('token')) {
            yield put(getUserFetch());
        }
    } catch (error) {
        // yield put(logoutFetchFailure({ error }));
        yield put(logoutFetchFailure({}));
    }

    yield call(() => {
        cleareLocalStorage();
    });

    if (action.payload?.navigate) {
        action.payload.navigate('/');
    }

    yield call(() => {
        window.location.reload();
    });

    yield put(setLogged(false));
}

export function* logoutFetchWatch() {
    yield takeEvery('login/logoutFetch', logoutFetch);
}
